module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAENSURBVHgBpdTLDYJAEADQmUXEoyVYAi14VC9agTH+wtEOtAhDYozYgXowHo0V2AIleFQJjAwR44ddljiXXXY2j2V2AkIcq+WhewuuJ8fp+FAgPG9TjQLLu4e3ieAFimhaNqyj625qRRAKysd42jaFZSeQCLHOoy6WIgRox8foDcbNLb6S7qEWGcRvgPioddlnfiP9UWvN6/ixKQeTIT+QClMhmVAWVqnARYVIoW8MgS4qRAlxLOZ72zDxzPOIaDYct6ayvUKW4JqUTPCej75A7KpaQ8iQ95ro9BnmIWlN8loDdZBXXoGhLpKHYRFEhSXQarE/6yIyLLm1kGBXBOHoOQ0/vU3+jcC/wWXh8QFILPwvMpMOEQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/Booking/cross.png
// module id = 452
// module chunks = 0